// extracted by mini-css-extract-plugin
export default {"tile__footer":"q171X","tile__footer--wide":"FpCoN","tile__footer__link":"K8kuv","tile__footer__link--half":"Ly1Ro","tile__footer__link--top-spacing":"q9Ihh"};